import { takeLatest, put, call } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { GetTrackContactCreationResponse } from '../../types/trackContactCreation/trackContactCreation.types';
import {
  GET_TRACK_CONTACT_CREATION_REQUEST,
  GetTrackContactCreationRequestAction,
} from './trackContactCreation.types';
import {
  getTrackContactCreationSuccess,
  getTrackContactCreationFailure,
} from './trackContactCreation.action';
import * as trackContactCreationService from '../../services/trackContactCreationService/trackContactCreationService';

// Worker Saga
function* getTrackContactCreationWorker(
  action: GetTrackContactCreationRequestAction
): SagaIterator {
  try {
    const response: GetTrackContactCreationResponse = yield call(
      trackContactCreationService.getTrackContactCreation,
      action.payload
    );
    yield put(getTrackContactCreationSuccess(response));
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      'Failed to fetch track contact creation';
    yield put(getTrackContactCreationFailure(errorMessage));
  }
}

// Root Saga
export function* trackContactCreationSaga(): SagaIterator {
  yield takeLatest(
    GET_TRACK_CONTACT_CREATION_REQUEST,
    getTrackContactCreationWorker
  );
}
